import { render, staticRenderFns } from "./SiteEditDialog.vue?vue&type=template&id=129c56b2&"
import script from "./SiteEditDialog.vue?vue&type=script&lang=ts&"
export * from "./SiteEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports